/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceCtaAction } from './SurfaceCtaAction';
import {
    SurfaceCtaActionFromJSON,
    SurfaceCtaActionFromJSONTyped,
    SurfaceCtaActionToJSON,
    SurfaceCtaActionToJSONTyped,
} from './SurfaceCtaAction';

/**
 * 
 * @export
 * @interface SurfaceCtaConfig
 */
export interface SurfaceCtaConfig {
    /**
     * 
     * @type {string}
     * @memberof SurfaceCtaConfig
     */
    headline?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCtaConfig
     */
    subtext?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCtaConfig
     */
    buttonText?: string;
    /**
     * 
     * @type {SurfaceCtaAction}
     * @memberof SurfaceCtaConfig
     */
    buttonAction?: SurfaceCtaAction;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCtaConfig
     */
    buttonUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceCtaConfig
     */
    targetSectionId?: string;
}



/**
 * Check if a given object implements the SurfaceCtaConfig interface.
 */
export function instanceOfSurfaceCtaConfig(value: object): value is SurfaceCtaConfig {
    return true;
}

export function SurfaceCtaConfigFromJSON(json: any): SurfaceCtaConfig {
    return SurfaceCtaConfigFromJSONTyped(json, false);
}

export function SurfaceCtaConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceCtaConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'headline': json['headline'] == null ? undefined : json['headline'],
        'subtext': json['subtext'] == null ? undefined : json['subtext'],
        'buttonText': json['buttonText'] == null ? undefined : json['buttonText'],
        'buttonAction': json['buttonAction'] == null ? undefined : SurfaceCtaActionFromJSON(json['buttonAction']),
        'buttonUrl': json['buttonUrl'] == null ? undefined : json['buttonUrl'],
        'targetSectionId': json['targetSectionId'] == null ? undefined : json['targetSectionId'],
    };
}

export function SurfaceCtaConfigToJSON(json: any): SurfaceCtaConfig {
    return SurfaceCtaConfigToJSONTyped(json, false);
}

export function SurfaceCtaConfigToJSONTyped(value?: SurfaceCtaConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'headline': value['headline'],
        'subtext': value['subtext'],
        'buttonText': value['buttonText'],
        'buttonAction': SurfaceCtaActionToJSON(value['buttonAction']),
        'buttonUrl': value['buttonUrl'],
        'targetSectionId': value['targetSectionId'],
    };
}

